import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getReportingStatusList as getReportingStatusListApi,
	getReportingStatusListQuery as getReportingStatusListQueryApi,
	getReportingStatus as getReportingStatusApi,
	addNewReportingStatusApi,
	updateReportingStatusApi,
	deleteReportingStatusApi,
	checkReportingStatusExistsApi,
} from '../../helpers/reporting_status/api_helper';

export const getReportingStatusList = createAsyncThunk(
	'reportingStatus/getReportingStatusList',
	async () => {
		try {
			const response = await getReportingStatusListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las condiciones de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getReportingStatusListQuery = createAsyncThunk(
	'reportingStatus/getReportingStatusListQuery',
	async params => {
		try {
			const response = getReportingStatusListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getReportingStatus = createAsyncThunk(
	'reportingStatus/getReportingStatus',
	async reporting_status_id => {
		try {
			const response = await getReportingStatusApi(reporting_status_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la condición de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewReportingStatus = createAsyncThunk(
	'reportingStatus/addNewReportingStatus',
	async reporting_status => {
		try {
			const response = await addNewReportingStatusApi(reporting_status);
			toast.success('Condición de Reportabilidad agregada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la condición de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateReportingStatus = createAsyncThunk(
	'reportingStatus/updateReportingStatus',
	async reporting_status => {
		try {
			const response = await updateReportingStatusApi(reporting_status);
			toast.success('Condición de Reportabilidad actualizada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la condición de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteReportingStatus = createAsyncThunk(
	'reportingStatus/deleteReportingStatus',
	async reporting_status => {
		try {
			const response = await deleteReportingStatusApi(reporting_status._id);
			toast.success('Condición de Reportabilidad eliminada exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return reporting_status;
		} catch (error) {
			toast.error('Error al eliminar la condición de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkReportingStatusExists = createAsyncThunk(
	'reportingStatus/checkReportingStatusExists',
	async name => {
		try {
			const response = await checkReportingStatusExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
